import { Component, OnInit, OnDestroy, ViewChild, ElementRef, ChangeDetectorRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { DynamicGrid } from '../../models/dynamic.model';
import { LazyLoadEvent, MessageService } from 'primeng/api';
import { NavigationService } from '../../services/navigation.service';
import { BaseListComponent } from '../../models/base/base-list.component';
import { ListService } from '../../services/list.service';
import { FormService } from '../../services/form.service';
import { RowToolEvent, RowTools } from '../../models/row-tools.model';
import { LookupService } from '../../services/lookup.service';
import { SharedService } from '../../services/shared.service';
import { AccountService } from '../../services/account.service';
import { Subject, takeUntil } from 'rxjs';
import * as Sentry from '@sentry/angular';

@Component({
  selector: 'user-list',
  templateUrl: 'user-list.component.html',
  providers: [
    ListService,
    FormService,
    LookupService,
  ],
  styles: [`
        :host ::ng-deep .ui-table .ui-table-thead > tr > th {
            position: -webkit-sticky;
            position: sticky;
            top: 0;
            background: #EBEBEB;
            border-bottom: 1px solid #D8D8D8;
        }
`]
})
export class UserListComponent extends BaseListComponent implements OnInit, OnDestroy {
  showOrderModal: boolean = false;
  showLocationModal: boolean = false;
  rowToolsArr: RowTools[] = [];
  @ViewChild("orderDialog", { static: false }) dialogRef: ElementRef;
  prevLazyLoadEvent: LazyLoadEvent | null = null;
  private destroy$ = new Subject<void>();

  constructor(
    protected messageService: MessageService,
    private router: Router,
    private listService: ListService,
    private sharedService: SharedService,
    private navigationService: NavigationService,
    private lookupService: LookupService,
    private formService: FormService,
    private accountService: AccountService,
    private route: ActivatedRoute,
    private cd: ChangeDetectorRef
  ) {
    super();
  }

  ngOnInit() {
    this.isLoading = true;

    this.class = 'user';
    this.setTitle();

    this.model = new DynamicGrid<any>();

    this.model.clearCols();

    this.model.addHidden('id');
    this.model.addCol('text', 'email', 'Email', 160);
    this.model.addCol('text', 'fullName', 'Name', 220);
    this.model.addCol('text', 'allowLogin', 'Allow Login', 120);
    this.model.addCol('text', 'isAdmin', 'Is Admin', 120);
    this.model.addCol('text', 'roleName', 'Role', 120);
    this.model.addCol('text', 'updatedByName', 'Updated By', 160);
    this.model.addCol('datetime', 'updatedOn', 'Updated On', 140);


    this.navigationService.showTopNav(true);
    this.navigationService.setTitle('Users');
    this.navigationService.setLeftNav(null, 'users');
    this.navigationService.showFilter(true, true);
    this.navigationService.showButton(true);
    this.navigationService.clearButton();

    let leftNav = this.navigationService.getNav().leftNav;
    if (leftNav != null) {
      if (leftNav.child != this.childKey && leftNav.child != '') {
      }
      this.childKey = leftNav.child;

    }

    this.subs['clickButton'] = this.navigationService.clickNewUser$.subscribe(s => {
      this.add();
    });

    this.subs['clickOrderButton'] = this.navigationService.clickNewOrder$.subscribe(s => {
      this.addOrder();
    });

    this.subs['clickLocationButton'] = this.navigationService.clickNewLocation$.subscribe(s => {
      this.addLocation();
    });

    this.subs['leftNav'] = this.navigationService.leftNav$.subscribe(v => {
      this.prevLazyLoadEvent=null;
      if (v.child != this.childKey && v.child != '') {
        this.clickChild(v.child, false);
      }
      this.childKey = v.child;
      this.cd.markForCheck();
    });

    this.subs['filter'] = this.navigationService.filter$.subscribe(s => {
      // this.resetGridState();
      if (this.query != s) {
        this.first = 0;
      }
      if (this.prevLazyLoadEvent) {
        this.prevLazyLoadEvent.first = 0;
      }
      this.query = s;
      this.load();
      this.cd.markForCheck();
    });

    this.route.queryParams.subscribe(p => {
      if (!p || Object.keys(p).length === 0 && (this.params.roleId || this.params.taxIdVerified || this.params.audit)) {
        // Set to default
        delete this.params.roleId;
        delete this.params.taxIdVerified;
        delete this.params.audit;
        this.setTitle();
        this.load();
      }
      if (p['preview'] != null && p['preview'] !== '') {
        this.view(p['preview']);
      }
      if (p['show'] != null && p['show'] !== '') {
        this.edit({ id: p['show'] });
      }
      this.cd.markForCheck();
    });

    this.loadLookup('yesNoNa');

  }

  setTitle() {
    if (this.params.roleId === 1) {
      this.title = 'User (Customers)';
    } else if (this.params.roleId === 2 && this.params.taxIdVerified === true) {
      this.title = 'Carriers (Tin Verification Required)';
    } else if (this.params.roleId === 2 && this.params.audit === true) {
      this.title = 'Carriers (Profile Audit Needed)';
    } else if (this.params.roleId === 2) {
      this.title = 'User (Carriers)';
    } else if (this.params.roleId === 3) {
      this.title = 'User (Agents)';
    } else {
      this.title = 'Users';
    }
  }

  ngOnDestroy() {
    this.safeUnsub('clickButton');
    this.safeUnsub('clickLocationButton');
    this.safeUnsub('filter');
    this.safeUnsub('leftNav');
    this.destroy$.next();
    this.destroy$.complete();
  }

  lazyLoad(e: any) {
    if (this.prevLazyLoadEvent && this.sharedService.isSameEvent(e, this.prevLazyLoadEvent)) {
      return;
    }
    setTimeout(() => {
      this.prevLazyLoadEvent = e;
      if (e.globalFilter == null) {
        e.globalFilter = this.query;
      }
      this.setGridState(e);
      this.load();
    }, 0);
      
  }

  clickRowTools(event: RowToolEvent) {
    this.selection = event.item;
    switch (event.key) {
      case 'delete':
        this.selection = event.item;
        this.isDeleting = true;
        break;
      case 'edit':
        this.edit(event.item);
        break;
      case 'view':
        this.view(event.item.guid);
        break;
    }
  }
  setRowTools(item: any) {
    this.rowTools = new RowTools();
    if (item.roleId == 3) {
      if (this.sharedService.getPermissions("can_delete") && (item.id!=3 && item.id!=5864 && item.id!= 5865)) {
        this.rowTools.addKebob("delete", "Delete");
      }
      if (this.sharedService.getPermissions('agents_edit') || this.sharedService.getPermissions('agents')) {
        this.rowTools.addLink('edit', 'View');
      }
    }
    if (item.roleId == 2) {
      if (this.sharedService.getPermissions("can_delete")) {
        this.rowTools.addKebob("delete", "Delete");
      }

      if (this.sharedService.getPermissions('carriers_edit') || this.sharedService.getPermissions('carriers')) {
        this.rowTools.addLink('edit', 'View');
      }
    }
    if (item.roleId == 1) {
      if (this.sharedService.getPermissions("can_delete")) {
        this.rowTools.addKebob("delete", "Delete");
      }

      if (this.sharedService.getPermissions('customers_edit') || this.sharedService.getPermissions('customers')) {
        this.rowTools.addLink('edit', 'View');
      }
    }

    this.rowToolsArr.push(this.rowTools);
  }
  delete() {
    if (this.selection != null) {
      this.formService
        .delete("user", this.selection.guid)
        .pipe(takeUntil(this.destroy$))
        .subscribe(
          (r) => {
            this.isDeleting = false;
            this.selection = null;
            this.messageService.add(
              this.toast(true, "User deleted successfully.")
            );
            this.sharedService
              .getMenuCount("users")
              .subscribe((res) => {
                this.navigationService.menuCountChange(res.body, "users");
              });
            this.sharedService
              .getMenuCount("tenderslocations")
              .subscribe((res) => {
                this.navigationService.menuCountChange(
                  res.body,
                  "tenderslocations"
                );
              });
            this.load();
          },
          (err) => {
            this.messageService.add(this.toast(false, "Error occurred"));
            console.error(err);
          }
        );
    }
  }

  cancelDelete() {
    this.isDeleting = false;
  }

  clickChild(e: any, selected: boolean) {
    let roles = {
      'customers': 1,
      'carriers': 2,
      'agents': 3,
    };
    this.resetGridState();
    if (selected) {
      delete this.params.roleId;
      delete this.params.taxIdVerified;
      delete this.params.audit;
    } else {
      if (roles[e] != null) {
        this.params.roleId = roles[e];
        delete this.params.taxIdVerified;
        delete this.params.audit;
      } else if (e === 'tax_id_verified_with_irs') {
        this.params.roleId = 2; // carriers
        this.params.taxIdVerified = true;
        delete this.params.audit;
      } else if (e === 'profile_audit') {
        this.params.roleId = 2;
        this.params.audit = true;
        delete this.params.taxIdVerified;
      }
    }

    let queryParams: any = {};
    if (this.params.roleId) {
      queryParams.roleId = this.params.roleId;
    }
    if (this.params.taxIdVerified) {
      queryParams.taxIdVerified = this.params.taxIdVerified;
    }
    if (this.params.audit) {
      queryParams.audit = this.params.audit;
    }

    this.router.navigate([], { queryParams: queryParams });
    this.setTitle();
    this.load();

  }


  load() {
    this.isLoading = true;
    this.model.rows = [];
    this.rowToolsArr = [];
    this.rowCount = this.first == 0 ? 0 : this.rowCount;
    this.listService
      .users(
        this.params,
        this.query,
        this.first,
        this.rows,
        this.sortField,
        this.sortOrder
      )
      .pipe(takeUntil(this.destroy$))
      .subscribe((res) => {
        this.loadColumns(res.body.metadata);

        // res.body.results.forEach(ele=> this.setRowTools(ele))
        // this.model.rows = res.body.results;

        let updatedResult = res.body.results.map((data) => {
          this.setRowTools(data);
          data.totalMoves = data.totalMoves ?? 0;
          data.top10OntimePer =
            (data.top10OntimePer ?? 0) +
            "%" +
            "  (" +
            (data.top10Ontime ?? 0) +
            ")";
          data.top10CancelPer =
            (data.top10CancelPer ?? 0) +
            "%" +
            "  (" +
            (data.top10Cancel ?? 0) +
            ")";
          data.dateoverhaulOntimePer =
            (data.dateoverhaulOntimePer ?? 0) +
            "%" +
            "  (" +
            (data.dateoverhaulOntime ?? 0) +
            ")";
          data.dateoverhaulCarrierCancelledPer =
            (data.dateoverhaulCarrierCancelledPer ?? 0) +
            "%" +
            "  (" +
            (data.dateoverhaulCarrierCancelled ?? 0) +
            ")";
          data.alltimeontimePer =
            (data.alltimeontimePer ?? 0) +
            "%" +
            "  (" +
            (data.allTimeOntime ?? 0) +
            ")";
          data.alltimeCarrierCancellationPer =
            (data.alltimeCarrierCancellationPer ?? 0) +
            "%" +
            "  (" +
            (data.allTimeCarrierCancellation ?? 0) +
            ")";
          return data;
        });

        this.model.rows = updatedResult;
        this.rowCount = res.body.count;
        this.isLoading = false;
        this.navigationService.setTitleAndSub({
          title: this.title,
          subtitle: this.rowCount + " total",
        });
      });

  }

  view(id: string) {
    this.navigationService.setDetail('user', id);
  }

  rowChangePreview(id: string) {
    if (this.navigationService.getNav().showRightNav) {
      this.navigationService.setRightNav('user', id);
    }
  }

  edit(row: any) {
    this.selection = row;
    this.showModal = true;
    this.isAdding = false;
  }

  add() {
    this.selection = null;
    this.showModal = true;
    this.showOrderModal = false;
    this.isAdding = true;
  }

  addOrder() {
    this.selection = null;
    this.showOrderModal = true;
    this.showModal = false;
    this.isAdding = true;
  }

  addLocation(){
    this.showLocationModal = true;
    this.selection = null;
    this.showModal = false;
    this.showOrderModal = false;
  }

  onUserSaveComplete(event: any) {
    this.load(); 
    if (this.isAdding) {
      this.cancel(event);
    }
  }

  cancel(event?: any) {
    if (typeof event === 'boolean' && event === false) {
      this.showOrderModal = true;
      return;
    }
    this.showOrderModal = false;
    let orderIdsToUnlock: number[] = [];

    if (event && Array.isArray(event) && event.length > 0) {
      orderIdsToUnlock = event;
    }

    if (orderIdsToUnlock.length > 0) {
      this.accountService.setAllowOrdersEdit(orderIdsToUnlock)
        .subscribe({
          error: (error) => {
            Sentry.captureException(new Error('Failed to unlock orders: ' + orderIdsToUnlock.join(', ')), { extra: { error } });
          }
        });
    }

    this.showModal = false;
    this.isEditing = false;
    this.isAdding = false;
    this.isDeleting = false;
    this.showLocationModal = false;
  }

  loadLookup(key: string, force: boolean = false) {
    this.lookupService
      .get(key, force)
      .pipe(takeUntil(this.destroy$))
      .subscribe((r) => {
        this.lookups[key] = r;
      });
  }

  rowColor(item: any): string {
    if (item.colourCode) {
      return item.colourCode;
    } else {
      return null;
    }
  }

  
  private isDarkMode(): boolean {
    return localStorage.getItem('isDarkMode') === 'true';
  }

  getColumnTextColor(col, item): string {
    if (col.key == 'fullName' && item.carrierStatus && this.isDarkMode()) {
      switch (item.carrierStatus) {
        case 1: return '#212121';
        case 3: return '#212121';
        case 4: return '#ffffff';
        case 5: return '#212121';
        default: return null;
      }
    }
    return null;
  }

  getColumnStyle(col, item) {
    if(col.key=='fullName'){
      if (item.carrierStatus) {
        switch (item.carrierStatus) {
          case 1:
          item.colourCode=null;
           return '#7CFC00';
          case 2:
            return null;
          case 3:
           item.colourCode=null;
           return '#ffff00';
          case 4:
           item.colourCode=null;
           return '#ffa500';
          case 5:
           item.colourCode=null;
           return '#f44336';
          default:
            return null;
        }
      }

      return null;
    }
  }


}
